import type { VarianceIncident } from '../models/variance-incident.model';
import { apiIncidentStatusToUi } from './incident-status-api.mapper';

function pickStr(obj: Record<string, unknown>, ...keys: string[]): string {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  return '';
}

function pickNum(obj: Record<string, unknown>, ...keys: string[]): number {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    if (typeof v === 'string' && /^\d+$/.test(v)) return Number.parseInt(v, 10);
  }
  return 0;
}

/**
 * Maps GET api/incidents/{id} JSON (PascalCase or camelCase) to VarianceIncident.
 */
export function mapIncidentApiPayloadToVarianceIncident(raw: unknown): VarianceIncident {
  const r = raw as Record<string, unknown>;
  const id = pickNum(r, 'id', 'Id');
  const incidentNum = pickNum(r, 'incidentNumber', 'IncidentNumber') || id;
  const varianceSnake = (pickStr(r, 'varianceStatus', 'VarianceStatus') || 'open').toLowerCase();

  return {
    id,
    incidentId: id,
    incidentNumber: String(incidentNum || id),
    medicationName: pickStr(r, 'medicationName', 'MedicationName'),
    employee: {
      name: pickStr(r, 'userName', 'UserName'),
      id: pickStr(r, 'userId', 'UserId'),
    },
    patient: {
      name: pickStr(r, 'patientName', 'PatientName'),
      id: pickStr(r, 'patientId', 'PatientId'),
    },
    status: apiIncidentStatusToUi(varianceSnake),
  };
}
